import { Controller } from "@hotwired/stimulus"

// Shows one block while a switch is on and another while it is off — a form
// whose fields depend on a yes/no choice (#17116: Settings → Regulatory
// Requirements, where "Use My Profile Business Address" on shows the profile
// address read-only and off shows the email-only address fields).
//
// The switch may also be a radio button (on while it is the chosen one, #20900:
// Pick a date), or a text field (#20852: the Intake Blocks form, where an
// IP address hides the How long picker): it is "on" while it has a value.
//
// The server renders the right block visible already; this controller only
// keeps them in step as the switch moves. Hidden fields stay in the form and
// still submit — the server decides what they mean from the switch.
//
// Usage:
//   <div data-controller="switch-reveal">
//     <input type="checkbox" data-switch-reveal-target="switch"
//            data-action="change->switch-reveal#sync">
//     <div data-switch-reveal-target="whenOn">…</div>
//     <div data-switch-reveal-target="whenOff">…</div>
//   </div>
export default class extends Controller {
  static targets = ["switch", "whenOn", "whenOff"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasSwitchTarget) return

    const field = this.switchTarget
    const on = field.type === "checkbox" || field.type === "radio" ? field.checked : field.value.trim() !== ""
    this.whenOnTargets.forEach((element) => { element.hidden = !on })
    this.whenOffTargets.forEach((element) => { element.hidden = on })
  }
}
